module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/3ISkNl/tc-custom/9781452132204.jpg?1705026024094",
      "alt": "This image is the cover for the book Commando Dad: A Basic Training Manual for the First Three Years of Fatherhood"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Commando Dad: A Basic Training Manual for the First Three Years of Fatherhood\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An indispensable training manual for new recruits to fatherhood—written by an ex-Commando and dad of three.")]), _c('br'), _c('br'), _c('i', [_vm._v("Commando Dad")]), _vm._v(" provides clear and logical advice on all the practicalities of becoming a new father and offers simple, helpful instruction for all obstacles along the way. Neil Sinclair teach prospective fathers, in no-nonsense terms, how to survive the first twenty-four hours; how to Prepare and Plan to Prevent Poor Parental Performance; how to maintain morale in the ranks; how to feed, clothe, transport, and entertain your troops; how to transport the troops successfully on maneuvers; how to increase your “flash to bang” time and “square away” tasks along the way.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Neil Sinclair\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Neil Sinclair has been a Royal Engineer Commando, a physical education teacher, and a licensed childcare provider. He is a full-time dad living in London, England.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle Books LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0